import { green, grey, orange, red } from "designSystem/styles/color";
import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import { AttributeMonitorContext } from "csi/heading/AttributeMonitor";
import Enum from "csi/heading/Enum";
import html from "csi/html";
import locale from "csi/locale";
import { C8Node, ICache } from "csi/typings";
import TextWithMaterialIcon from "csi/widget/TextWithMaterialIcon";
import xml from "csi/xml";
import declare from "dojo/_base/declare";
import _ from "underscore";
import {
	ENUM_APPROVED_WITH_CHANGES,
	ENUM_APPROVED,
	ENUM_REVIEW_COMPLETE,
	getIconParameters
} from "./ProofService";

function isProofLate(proofWorkflowInstance: C8Node, cache: ICache): boolean {
	if (!proofWorkflowInstance) {
		return false;
	}

	const stage = cache.get(proofWorkflowInstance.Subprocesses[0]);
	if (!stage) {
		return false;
	}

	const dueDate = cache.get(stage.Tasks[0]).DueDate;
	if (!dueDate) {
		return false;
	}

	const dateNow = Date.now();
	const bLate = dueDate < dateNow;
	return bLate;
}

export = declare(Enum, {
	/**
	 * @override
	 * Redraw the view when updated
	 */
	onMonitor(amc: AttributeMonitorContext, newValue) {
		amc.ctx.view.refreshData();
		return true;
	},

	/**
	 * @override
	 * Draw status icon and name, pill "Late" and popup button
	 */
	toHtmlStatic(ctx: Context, h: Heading, refNode: HTMLElement, _params) {
		const enumValue = this._getValue(ctx, h);
		const value = xml.enumGetText(enumValue);

		const revisionNode = ctx.getNode();

		// status icon and status text
		new TextWithMaterialIcon(getIconParameters(value, false, true, this.toValue(ctx, h)))
			.placeAt(refNode);

		const cache = ctx.cache;
		const proofWorkflowInstance = cache.getNode(revisionNode.ProofWorkflow);
		const bLate = isProofLate(proofWorkflowInstance, cache);

		// late pill
		if (bLate && (value != ENUM_APPROVED_WITH_CHANGES) && (value != ENUM_APPROVED) && (value != ENUM_REVIEW_COMPLETE)) {
			html.create("span", {
				class: "csi-proofing-status-late",
				innerText: locale.resource("StateLate")
					.toUpperCase(),
			}, refNode);
		}

		if (revisionNode.ProofIsLocked) {
			new TextWithMaterialIcon(getIconParameters("Locked", true, false))
				.placeAt(refNode);
		}

		return true;
	},
});
